import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'colorConverter',
    pure: true,
    standalone: false
})
export class ColorConverterPipe implements PipeTransform {
  transform(value: string, ...args: string[]): string {
    let mode = 'dec';
    if (args.length) {
      mode = args[0];
    }

    if (mode.toLowerCase() === 'todec') {
      return this.toDecimal(value);
    } else if (mode.toLowerCase() == 'tohex') {
      return this.toHex(value);
    }

    return value;
  }

  toDecimal(value: string) {
    if (!value) {
      return '0';
    }
    if (value[0] == '#') {
      value = value.substr(1);
    }

    const bbggrr = value.substr(4, 2) + value.substr(2, 2) + value.substr(0, 2);
    return parseInt(bbggrr, 16).toString();
  }

  toHex(value: string) {
    let intnumber = parseInt(value, 10);
    const template = '#000000';

    /* tslint:disable:no-bitwise */
    const red = (intnumber & 0x0000ff) << 16;
    const green = intnumber & 0x00ff00;
    const blue = (intnumber & 0xff0000) >>> 16;

    intnumber = red | green | blue;
    /* tslint:enable:no-bitwise */

    let HTMLcolor = intnumber.toString(16);
    HTMLcolor = template.substring(0, 7 - HTMLcolor.length) + HTMLcolor;

    return HTMLcolor;
  }
}
